<!-- TODO: errors -->
<template>
    <div class="mt-8 px-4 lg:max-w-6xl lg:mx-auto">
        <template v-if="errors && errors.picture">
            <p class="text-center mb-4 bg-red-600 text-white font-bold text-lg" v-for="error in errors.picture">
                {{ error }}
            </p>
        </template>
        <form :action="'/' + user.slug + '/gallery/add'" class="max-w-screen-lg mx-auto" method="POST" key="artist-create">
            <input type="hidden" name="_token" v-model="token">

            <div class="form-box-item" style="width: 100%;">
                <h4>Galerie photo</h4>
                <hr class="line-separator">

                <file-pond
                    id="picture"
                    name="pictures[]"
                    ref="pond"
                    class-name="my-pond"
                    label-idle="Déposer vos fichiers ici"
                    allow-multiple="true"
                    accepted-file-types="image/jpeg, image/png"
                    :files="null"
                    :maxFiles="10 - user.pictures.length"
                />
            </div>

            <button type="submit" class="btn -pink text-white border border-transparent rounded-md py-2 px-4 inline-flex justify-center text-sm leading-5 hover:text-gray-200 focus:outline-none transition duration-150 ease-in-out">Ajouter</button>
        </form>
    </div>
</template>

<script>
    import Axios from "axios"

    import vueFilePond, { setOptions } from 'vue-filepond';

    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';

    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    const FilePond = vueFilePond( FilePondPluginFileValidateType, FilePondPluginImagePreview );

    export default {
        props: {
            token: String,
            user: Object,
        },
        beforeMount() {
            setOptions({
                server: {
                    process: (fieldName, file, metadata, load, error, progress, abort, transfer, options)  => {
                        const formData = new FormData();
                        formData.append('picture', file, file.name);

                        Axios.post('/pictures/process', formData)
                            .then( response => {
                                load(response.data);
                            })
                            .catch( error => {
                                console.warn(error)
                                if(error.response.status === 422) {
                                    console.warn(error.response.data.errors);
                                    this.errors = error.response.data.errors;
                                }
                            })
                    },
                    revert: (uniqueFieldId, load, error) => {
                        Axios.delete('/pictures/revert/' + uniqueFieldId)
                            .then( response => {
                                load();
                            })
                            .catch( error => {
                                console.warn(error)
                            });
                    }
                }
            });
        },
        data() {
            return {
                errors: []
            }
        },
        components: {
            FilePond,
        }
    }
</script>
